export default {"src":"/_next/static/media/client-06.ea10a68b.svg","height":34,"width":78,"blurWidth":0,"blurHeight":0};